export function loadShareCodeInfo() {
  return {
    type: 'LOAD_SHARE_CODE_INFO',
  };
}

export function loadShareCodeInfoCompletion(error, data) {
  return {
    type: 'LOAD_SHARE_CODE_INFO_COMPLETION',
    data,
    error,
  };
}

export function loadInfoByShareCode(code) {
  return {
    type: 'LOAD_INFO_BY_SHARE_CODE',
    code,
  };
}

export function loadInfoByShareCodeCompletion(error, data) {
  return {
    type: 'LOAD_INFO_BY_SHARE_CODE_COMPLETION',
    data,
    error,
  };
}

export function updateShareCode(code) {
  return {
    type: 'UPDATE_SHARE_CODE',
    code,
  };
}

export function updateShareCodeCompletion(error, data) {
  return {
    type: 'UPDATE_SHARE_CODE_COMPLETION',
    data,
    error,
  };
}

export function syncShareCodeEditInput(input, reset) {
  return {
    type: 'SYNC_SHARE_CODE_EDIT_INPUT',
    input,
    reset,
  };
}

export function loadInfoByPhoneNumber(phone) {
  return {
    type: 'LOAD_INFO_BY_PHONE_NUMBER',
    phone,
  };
}

export function loadInfoByPhoneNumberCompletion(error, data) {
  return {
    type: 'LOAD_INFO_BY_PHONE_NUMBER_COMPLETION',
    data,
    error,
  };
}
export function syncManagerPhoneEditInput(input, reset) {
  return {
    type: 'SYNC_MANAGER_PHONE_EDIT_INPUT',
    input,
    reset,
  };
}

export function editManagerPhone(phone) {
  return {
    type: 'EDIT_MANAGER_PHONE',
    phone,
  };
}

export function editManagerPhoneCompletion(error, data) {
  return {
    type: 'EDIT_MANAGER_PHONE_COMPLETION',
    data,
    error,
  };
}
